const options = {
  5: "bg-stone-400/5",
  10: "bg-stone-400/10",
  25: "bg-stone-400/25",
  50: "bg-stone-400/50",
  75: "bg-stone-400/75",
  90: "bg-stone-400/90",
  100: "bg-stone-400",
};

const from = {
  5: "from-stone-400/5",
  10: "from-stone-400/10",
  25: "from-stone-400/25",
  50: "from-stone-400/50",
  75: "from-stone-400/75",
  90: "from-stone-400/90",
  100: "from-stone-400",
};

export default function getBackgroundStone400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
